import { useGame } from '../../context/GameContext';
import { matchesLevelKey } from '../../utils/ids';
import type { CatalogWorld } from '../../utils/worldCategories';
import { WorldCard } from './WorldCard';

export function WorldGrid({ worlds }: { worlds: CatalogWorld[] }) {
  const { gameData, isWorldUnlocked } = useGame();
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
    {worlds.map(({ info, world }) => <WorldCard key={world.id} world={world}
      isUnlocked={Boolean(info.alwaysUnlocked || isWorldUnlocked(world.id, world))}
      completedCount={world.levels.filter(level => gameData?.progress.completedLevels.some(id => matchesLevelKey(id, world.id, level.id))).length}
      totalCount={world.levels.length} />)}
  </div>;
}
